<template>
  <v-menu
    class="time-picker-wrap"
    transition="scale-transition"
    max-width="calc(100% - 30px)"
    min-width="360px"
    offset-y
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        prepend-icon="access_time"
        readonly
        v-bind="attrs"
        v-on="on"
        :value="time"
        :hideDetails="hideDetails"
        :error-messages="errorMessages.filter(Boolean)"
        :label="label"
        @input="$emit('input', $event)"
        @blur="$emit('blur', $event)"
      ></v-text-field>
    </template>
    <v-time-picker v-model="time" format="24hr">
      <v-btn text color="primary" @click="menu = false" class="d-none d-md-block">Отмена</v-btn>
      <v-btn text color="primary" @click="clearTime">Очистить</v-btn>
      <v-btn text color="primary" @click="updateTime">Применить</v-btn>
    </v-time-picker>
  </v-menu>
</template>

<script>
export default {
  name: "TimePicker",

  props: {
    label: {
      type: String,
      default: "Укажите время",
    },
    errorMessages: {
      type: Array,
      default: () => [],
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
    value: {},
  },

  data: () => ({
    menu: false,
    time: "",
  }),

  watch: {
    value: function(newVal) {
      this.time = newVal;
    },
  },

  mounted() {
    this.time = this.value;
  },

  methods: {
    clearTime() {
      this.menu = false;
      this.time = "";
      this.$emit("input", "");
    },

    updateTime() {
      this.menu = false;
      this.$emit("input", this.time);
    },
  },
};
</script>

<style scoped lang="scss">
.time-picker-wrap {
  display: flex;
  justify-content: center;
}
</style>
